module.exports = __webpack_public_path__ + "static/media/cf.ef296947.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cf.svg
// module id = 2060
// module chunks = 0